"use client";

import Image from "next/image";
import Link from "next/link";
import { useLocale, useTranslations } from "next-intl";

import { HelpSearch } from "./help-search";

export function HelpHeader() {
  const locale = useLocale();
  const t = useTranslations("help");

  return (
    <header className="sticky top-0 z-40 w-full border-b border-neutral-100 bg-white/80 backdrop-blur-md dark:border-neutral-800 dark:bg-black/80">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Link href={`/${locale}/help`} className="flex items-center gap-3">
          <Image
            src="/coldfire-logo.png"
            alt="Coldfire Hilfe"
            width={140}
            height={32}
            priority
            className="h-7 w-auto"
          />
          <span className="hidden text-sm font-medium text-muted dark:text-muted-dark sm:inline">
            {t("title")}
          </span>
        </Link>

        <div className="hidden flex-1 max-w-md md:block">
          <HelpSearch />
        </div>

        <div className="flex items-center gap-3 text-sm">
          <Link
            href={`/${locale}`}
            className="hidden text-muted hover:text-neutral-900 dark:text-muted-dark dark:hover:text-white sm:inline"
          >
            {t("backToWebsite")}
          </Link>
          <LocaleSwitcher currentLocale={locale} />
        </div>
      </div>

      <div className="border-t border-neutral-100 px-4 pb-3 pt-2 dark:border-neutral-800 md:hidden">
        <HelpSearch />
      </div>
    </header>
  );
}

function LocaleSwitcher({ currentLocale }: { currentLocale: string }) {
  const locales = ["de", "en"];
  return (
    <div className="flex items-center gap-1 text-xs">
      {locales.map((loc) => (
        <Link
          key={loc}
          href={`/${loc}/help`}
          className={
            loc === currentLocale
              ? "rounded bg-neutral-900 px-2 py-1 font-semibold text-white dark:bg-white dark:text-black"
              : "rounded px-2 py-1 text-muted hover:bg-neutral-100 dark:text-muted-dark dark:hover:bg-neutral-900"
          }
        >
          {loc.toUpperCase()}
        </Link>
      ))}
    </div>
  );
}
